import { render, staticRenderFns } from "./KpiSingleComponent.vue?vue&type=template&id=52b56df4&scoped=true&"
import script from "./KpiSingleComponent.vue?vue&type=script&lang=js&"
export * from "./KpiSingleComponent.vue?vue&type=script&lang=js&"
import style0 from "./KpiSingleComponent.vue?vue&type=style&index=0&id=52b56df4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b56df4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
